import {connect} from 'react-redux';
import Results from './results';
import {updateProgress} from '../../actions/progressActions';
import {fetchResults, resultsLoading} from '../../actions/resultActions';
import {updateFilteredResults} from '../../actions/filteredResultActions';
import {openModal} from '../../actions/modalActions';
import {clearPromptQueue} from '../../actions/promptQueueActions';
import {receiveAggregateFilters} from '../../actions/selectedFilter/inResultsActions';

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        selectedFilters: state.session.selectedFilters.inResults,
        allResults: state.entities.results
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateProgress: promptId => dispatch(updateProgress(promptId)),
        updateFilteredResults: filters => dispatch(updateFilteredResults(filters)),
        resultsLoading: () => dispatch(resultsLoading()),
        openModal: modal => dispatch(openModal(modal)),
        fetchResults: indexName => dispatch(fetchResults(indexName)),
        clearPromptQueue: () => dispatch(clearPromptQueue()),
        receiveAggregateFilters: filters => dispatch(receiveAggregateFilters(filters))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Results);
